var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4193 4.34925L9.1866 1.11938C8.79237 0.734868 8.24045 0.504163 7.60968 0.504163H2.95775C1.77506 0.427261 0.750061 1.42698 0.750061 2.58051V13.3468C0.750061 14.5003 1.69622 15.5 2.95775 15.5H10.8424C12.0251 15.5 13.0501 14.5772 13.0501 13.3468V5.81038C13.0501 5.27207 12.8135 4.73376 12.4193 4.34925ZM4.53468 6.5794H6.90006C7.21545 6.5794 7.53083 6.8101 7.53083 7.19461C7.53083 7.57912 7.29429 7.80983 6.90006 7.80983H4.53468C4.21929 7.80983 3.90391 7.57912 3.90391 7.19461C3.90391 6.8101 4.21929 6.5794 4.53468 6.5794ZM9.26545 10.8859H4.53468C4.21929 10.8859 3.90391 10.6552 3.90391 10.2707C3.90391 9.88617 4.14045 9.65547 4.53468 9.65547H9.26545C9.58083 9.65547 9.89622 9.88617 9.89622 10.2707C9.89622 10.6552 9.58083 10.8859 9.26545 10.8859Z",
    fill: "#666C95"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.8d06074c.svg";
export { ForwardRef as ReactComponent };